import { useState } from 'react';

const rankingTabs = ['热播榜', '新剧榜', '电影榜'];

const rankingData: Record<string, { title: string; desc: string; score: string }[]> = {
  '热播榜': [
    { title: '长安十二时辰', desc: '古装悬疑 · 雷佳音 / 易烊千玺', score: '9.2' },
    { title: '流浪地球3', desc: '科幻灾难 · 吴京 / 刘德华', score: '8.9' },
    { title: '繁花', desc: '都市商战 · 胡歌 / 马伊琍', score: '9.1' },
    { title: '漫长的季节', desc: '悬疑剧情 · 范伟 / 秦昊', score: '9.4' },
    { title: '黑暗荣耀', desc: '复仇剧情 · 宋慧乔', score: '9.1' },
    { title: '去有风的地方', desc: '田园治愈 · 刘亦菲 / 李现', score: '8.8' },
    { title: '鱿鱼游戏2', desc: '生存游戏 · 李政宰', score: '8.7' },
  ],
  '新剧榜': [
    { title: '庆余年2', desc: '古装权谋 · 张若昀 / 李沁', score: '9.3' },
    { title: '猎罪图鉴2', desc: '刑侦悬疑 · 檀健次', score: '8.6' },
    { title: '三体', desc: '科幻巨制 · 张鲁一 / 于和伟', score: '8.5' },
    { title: '鬼灭之刃 柱训练篇', desc: '热血动漫 · 花江夏树', score: '9.0' },
    { title: '与凤行', desc: '仙侠玄幻 · 赵丽颖 / 林更新', score: '8.4' },
    { title: '大奉打更人', desc: '古装奇幻 · 王鹤棣', score: '8.3' },
    { title: '玫瑰的故事', desc: '都市情感 · 刘亦菲', score: '8.7' },
  ],
  '电影榜': [
    { title: '流浪地球3', desc: '科幻 · 166分钟 · 2026', score: '8.9' },
    { title: '第二十条', desc: '剧情 · 张艺谋 · 141分钟', score: '8.8' },
    { title: '飞驰人生3', desc: '喜剧 · 沈腾 · 128分钟', score: '8.5' },
    { title: '热辣滚烫', desc: '剧情 · 贾玲 · 129分钟', score: '8.7' },
    { title: '猩球崛起4', desc: '科幻动作 · 145分钟', score: '8.3' },
    { title: '哥斯拉大战金刚3', desc: '动作科幻 · 118分钟', score: '8.4' },
    { title: '周处除三害', desc: '犯罪动作 · 134分钟', score: '8.6' },
  ],
};

export default function RankingSection() {
  const [activeTab, setActiveTab] = useState('热播榜');
  const items = rankingData[activeTab];

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-black text-foreground-900 mb-3">
            热播排行榜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            实时更新最受欢迎的影视排行，看看大家都在追什么
          </p>
        </div>

        <div className="flex items-center justify-center gap-1 mb-8 bg-background-50 rounded-full p-1 max-w-xs mx-auto border border-background-200/70">
          {rankingTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex-1 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === tab
                  ? 'bg-primary-500 text-white shadow-sm'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {items.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors duration-150 cursor-pointer no-underline ${
                idx < items.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className="flex-shrink-0 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-black text-sm md:text-base">
                {idx === 0 ? (
                  <span className="text-accent-500">
                    <i className="ri-medal-fill text-xl md:text-2xl"></i>
                  </span>
                ) : idx === 1 ? (
                  <span className="text-secondary-500">
                    <i className="ri-medal-fill text-xl md:text-2xl"></i>
                  </span>
                ) : idx === 2 ? (
                  <span className="text-secondary-400">
                    <i className="ri-medal-fill text-xl md:text-2xl"></i>
                  </span>
                ) : (
                  <span className="text-foreground-400">{idx + 1}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 truncate mt-0.5">
                  {item.desc}
                </p>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1">
                <i className="ri-star-fill text-accent-500 text-sm"></i>
                <span className="text-sm font-bold text-foreground-900">{item.score}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}